import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getProfessionalApi = createAsyncThunk('getprofessionalStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingProfessionalDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllProfessionals`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(professionalDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(professionalDetailClear())
                message.error(error) 
            })
    }
)


export const updateProfessionalStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateProfessionalStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(professionalstatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const GetProfessionalApiSlice = createSlice({
    name: 'Professionalgetapi',
    initialState: {
        proData: null,
        loadingpro: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingProfessionalDetail: state => {
            state.loadingpro=true
            state.proData=null
        },
        professionalDetailResponse: (state, action)=>{
            state.proData= action.payload
            state.loadingpro= false
        },
        professionalDetailClear: (state)=>{
            state.proData= null
            state.loadingpro= false
        },
        changeProfessionalDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        professionalstatusResponse: (state, action) => {
            const { id, status } = action.payload
            const proIndex = state.proData.findIndex(pro => pro.id === id)
            if (proIndex !== -1) {
                state.proData[proIndex].status = status
            }
            state.loadingpro = false
        }
    },
})
export const { 
    gettingProfessionalDetail, professionalDetailResponse, professionalDetailClear,
    changeProfessionalDetailFilters, setPages, professionalstatusResponse
} = GetProfessionalApiSlice.actions;
export default GetProfessionalApiSlice.reducer;